import { isPlainObject } from './obj'

/*
  generateSearchNeedle

  Create a string to test a search query against for filtering lists
  Recursively dive into an object or array looking for strings
  Ignores keys listed in `ignoreKeys` when iterating over objects
 */
export function generateSearchNeedle(
  thing: string | any[] | Record<string, any>,
  ignoreKeys: string[] = []
): string[] {
  if (typeof thing === 'string') {
    return [thing]
  }

  if (Array.isArray(thing)) {
    return thing.flatMap((v) => generateSearchNeedle(v, ignoreKeys))
  }

  if (isPlainObject(thing)) {
    return generateSearchNeedle(
      Object.entries(thing)
        .filter(([k]) => !ignoreKeys.includes(k))
        .map(([, v]) => v),
      ignoreKeys
    )
  }

  return []
}
